import React from 'react'
import { useKababContext } from '../../../../KababContext';
import {Col, Container, Row} from 'react-bootstrap';
import FormAddnewuser from './FormAddnewuser/FormAddnewuser'

function NewUserContent() {
  const { sidebarOpen } = useKababContext();
  const contentStyle = sidebarOpen ? 'Side-bar-closed' : 'Side-bar-open';
  return (
    <div className={contentStyle}>
      <p className='main-tital-adminpenal'>
        Add Users
      </p>
      <Container fluid>
        <Row>
          <Col md={12}><FormAddnewuser/></Col>
        </Row>
      </Container>
    </div>
  )
}

export default NewUserContent
